import { calendarViewOptionsRegionName } from './CalendarModule.locstring.json';
import CalendarModuleCanvas from './CalendarModuleCanvas';
import CalendarModuleCommandBar from './CalendarModuleCommandBar';
import CalendarModuleSurface from './CalendarModuleSurface';
import '../orchestrators/updateCurrentDateOrchestrator';
import { useCalendarModuleContentHotkeys } from '../utils/bindCalendarModuleContentHotKeys';
import { observer } from 'mobx-react-lite';
import {
    isCanvasViewTypeSelected,
    updateSelectedViewType,
    SelectedViewTypeSource,
} from 'owa-calendar-module-store';
import { getSearchState } from 'owa-calendar-search-view-store';
import { SearchResultsView } from 'owa-calendar-searchresults-view';
import { surfaceStore } from 'owa-calendar-surface-surface-store';
import { CalendarViewTypeEnum, CalendarViewTypeEnumToDateRangeType } from 'owa-calendar-view-type';
import { DateRange } from 'owa-datetime-utils';
import { isFeatureEnabled } from 'owa-feature-flags';
import { SaveCalendarDialog } from 'owa-save-calendar-view-dialog';
import SkipLinkRegionToFirstFocusableChild from 'owa-skip-link/lib/components/SkipLinkRegionToFirstFocusableChild';
import * as React from 'react';
import {
    processDateRangeTypeOrDayRangeChange,
    processDateRangeChange,
} from 'owa-calendar-surface-view-store';

// TODO: VSO #88707 Separate module vs surface concerns in Calendar module
// This file will be further decomposed in upcoming iterations to fully separate surface and canvas

const styles = require('./CalendarModule.scss');

export default observer(function CalendarModuleContent() {
    const isSurfaceViewType = !isCanvasViewTypeSelected();

    useCalendarModuleContentHotkeys(isSurfaceViewType, onViewTypeChange, onDateRangeChange);

    if (getSearchState()) {
        return <SearchResultsView />;
    }

    return (
        <div className={styles.rightPane}>
            <SkipLinkRegionToFirstFocusableChild
                role="navigation"
                regionNameResourceId={calendarViewOptionsRegionName}>
                <CalendarModuleCommandBar
                    onDateRangeChange={onDateRangeChange}
                    onViewTypeChange={onViewTypeChange}
                />
            </SkipLinkRegionToFirstFocusableChild>
            {isSurfaceViewType ? <CalendarModuleSurface /> : <CalendarModuleCanvas />}
            {isFeatureEnabled('cal-saveCalendarView') && (
                <SaveCalendarDialog surfaceStore={surfaceStore} />
            )}
        </div>
    );
});

function onDateRangeChange(newDateRange: DateRange) {
    processDateRangeChange(newDateRange, surfaceStore);
}

function onViewTypeChange(
    newCalendarViewType: CalendarViewTypeEnum,
    newNumOfDaysInDayRange?: number
) {
    updateSelectedViewType(newCalendarViewType, SelectedViewTypeSource.UserChange);
    processDateRangeTypeOrDayRangeChange(
        CalendarViewTypeEnumToDateRangeType(newCalendarViewType),
        surfaceStore,
        newNumOfDaysInDayRange
    );
}
